// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__gLMMu","container":"styles_container__Rkf_6","title":"styles_title__2Zuu-","wrapper":"styles_wrapper__3JOY5","answer":"styles_answer__2O0Fr"};